import { useState } from "react";
import { useLoading } from "@fac/react-hooks";
import { GOVCompany } from "./GOV.type";
import GOVService from "./GOV.service";

export const useGetGOVCompany = () => {
    const [company, setCompany] = useState<Partial<GOVCompany> | undefined>();
    const { wrapper, ...loadProps } = useLoading(true);

    const getCompany = async (cnpj: string): Promise<Partial<GOVCompany>> => (
        new Promise<Partial<GOVCompany>>((resolve) => {
            wrapper(async () => {
                const res = await GOVService.getCompany(cnpj);
                setCompany(undefined);
                setCompany(res.data);
                resolve(res.data);
            });
        })
    );

    return {
        getCompany,
        company,
        setCompany,
        ...loadProps,
    };
};

export const GOVHooks = {
    useGetGOVCompany,
};
